module.exports = __webpack_public_path__ + "assets/img/LGlogo.06e848c3.svg";